export default {
  'Sample photo': 'Örnek fotoğraf',
  Removing: 'Kaldırma',
  Edit: 'Düzenle',
  'Adjust Picture': 'Resmi Ayarla',
  Restore: 'Onar',
  Eraser: 'Silgi',
  Size: 'Boyut',
  Background: 'Arka plan',
  Custom: 'Özel',
  Presets: 'Ön ayarlar',
  'Add Image': 'Resim Ekle',
  'Scale to Fit': 'Sığdırmak için ölçek',
  'Full Width': 'Tam Genişlik',
  'Full Height': 'Tam Yükseklik',
  Move: 'Taşı',
  Undo: 'Geri al',
  Redo: 'Yinele',
  Enlarge: 'Büyüt',
  Reduce: 'Azalt',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw Çevrimiçi Arka Plan Kaldırıcı',
    desc: 'Fotoğraflarınızın arka planını kolayca %100 Otomatik ve Ücretsiz olarak kaldırın',
    imgAlt: 'photo background remover',
    submitBtn: 'Arka Planı Kaldır',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
